import { RequestBuilder } from '../request_builder'

export class UserIDRequestBuilder extends RequestBuilder {
  constructor (serverUrl) {
    super(serverUrl)
    this.segment = 'user_id'
  }

  forEmail (email) {
    this.addQuery('email', email)
    return this
  }

  forTaid (taid) {
    if (taid && taid.length > 0) this.addQuery('taid', taid)
    return this
  }

  forUplataInsha (uplataInsha) {
    if (uplataInsha && uplataInsha.length > 0) this.addQuery('uplata_insha', uplataInsha)
    return this
  }
}



// WEBPACK FOOTER //
// ./src/js/builders/request_builder/modules/user_id_request_builder.js